import { render } from "./distribute.vue?vue&type=template&id=e48eeff2&scoped=true"
import script from "./distribute.vue?vue&type=script&lang=js"
export * from "./distribute.vue?vue&type=script&lang=js"

import "./distribute.vue?vue&type=style&index=0&id=e48eeff2&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48eeff2"]])

export default __exports__